import { render, staticRenderFns } from "./carrierDetail.vue?vue&type=template&id=3eedebd4&scoped=true&"
import script from "./carrierDetail.vue?vue&type=script&lang=js&"
export * from "./carrierDetail.vue?vue&type=script&lang=js&"
import style0 from "./carrierDetail.vue?vue&type=style&index=0&id=3eedebd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eedebd4",
  null
  
)

export default component.exports